import { render, staticRenderFns } from "./GreetingHeader.vue?vue&type=template&id=c45c5960&scoped=true"
import script from "./GreetingHeader.vue?vue&type=script&lang=js"
export * from "./GreetingHeader.vue?vue&type=script&lang=js"
import style0 from "./GreetingHeader.vue?vue&type=style&index=0&id=c45c5960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45c5960",
  null
  
)

export default component.exports